import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=2dcea93c&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/nav.css?vue&type=style&index=0&id=2dcea93c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcea93c",
  null
  
)

export default component.exports